/**
 * Z-index value for the top layer content on rendered video
 * Used for watermarks
 */
export const TOP_LAYER_ZINDEX = 999;

/**
 * Default z-index value when no other value is specified
 */
export const DEFAULT_LAYER_ZINDEX = 0;

/**
 * Z-index value for "foreground" images
 * which sit above the bottom layer, but below most other things
 */
export const FOREGROUND_IMAGE_ZINDEX = -10;

/**
 * Z-index value for the bottom layer content on rendered video
 */
export const BOTTOM_LAYER_ZINDEX = -100;
